import { t } from 'i18next';

import { SiteRateSchedule } from '~hooks/useSiteRateSchedule/models';

/**
 * Derive a human-readable label for a SiteRateSchedule chip. Prefers the
 * schedule's explicit name when set, then falls back to a route label, then
 * conditions (material + equipment type), and finally to an i18n-driven
 * "Base Rate" fallback.
 */
export function deriveScheduleLabel(schedule: SiteRateSchedule): string {
  if (schedule.name && schedule.name.trim()) return schedule.name;

  const route = [schedule.pickupSite?.name, schedule.dropoffSite?.name]
    .filter(Boolean)
    .join(' \u2192 ');
  const conditions = [schedule.material?.name, schedule.equipmentType?.name]
    .filter(Boolean)
    .join(', ');

  if (route && conditions) return `${route} (${conditions})`;
  if (route) return route;
  if (conditions) return `(${conditions})`;
  return t('dispatch.job.rates.base_rate');
}
